import { apiClient } from "@/shared/apiClient";

export type ReportPermissions = {
  view_shift_reports: boolean;
  view_patrol_reports: boolean;
};

export const reportsApi = {
  async getReportPermissions(): Promise<ReportPermissions | null> {
    const response = await apiClient.get("/api/employee/report-permissions");
    // Temporary logging to help debug permissions from backend
    // eslint-disable-next-line no-console
    console.log("[reportsApi] raw /api/employee/report-permissions response", response);

    const payload =
      response && typeof response === "object" && "data" in response ? (response as any).data : response;

    // eslint-disable-next-line no-console
    console.log("[reportsApi] parsed report-permissions payload", payload);

    if (!payload || typeof payload !== "object") {
      return null;
    }

    const obj = payload as Record<string, unknown>;

    const viewShiftReports = Boolean(obj.view_shift_reports);
    const viewPatrolReports = Boolean(obj.view_patrol_reports);

    // If neither permission flag is present, treat as no permissions.
    if (!("view_shift_reports" in obj) && !("view_patrol_reports" in obj)) {
      return null;
    }

    const result: ReportPermissions = {
      view_shift_reports: viewShiftReports,
      view_patrol_reports: viewPatrolReports,
    };

    // eslint-disable-next-line no-console
    console.log("[reportsApi] normalized report-permissions result", result);

    return result;
  },
};

